import { Fragment, MouseEvent, useState } from "react";
import { Construction } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";

import type { ICraft } from "@framework/types";
import { Button, Menu } from "@dzambalaorg/ui-kit";

interface ICraftIngredientsProps {
  craft: ICraft;
}

export const CraftIngredients = (props: ICraftIngredientsProps) => {
  const { craft } = props;

  const [anchor, setAnchor] = useState<Element | null>(null);

  const handleMenuOpen = (event: MouseEvent): boolean => {
    event.preventDefault();
    event.stopPropagation();
    setAnchor(event.currentTarget);
    return false;
  };

  const handleMenuClose = (event: MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();
    setAnchor(null);
  };

  return (
    <Fragment>
      <Button
        intent="icon"
        aria-owns={anchor ? "craft-ingredients" : undefined}
        aria-haspopup="true"
        data-testid="CraftIngredients"
        onClick={handleMenuOpen}
        color="inherit"
      >
        <Construction />
      </Button>
      <Menu id="craft-ingredients" anchorEl={anchor} open={!!anchor} onClose={handleMenuClose}>
        {craft.price?.components.map(component => (
          <Menu.Item<typeof RouterLink>
            key={component.id}
            component={RouterLink}
            to={`/${component.contract?.contractType?.toLowerCase()}/templates/${component.template?.id}`}
          >
            <Menu.ItemText>
              {component.template!.title} {`${BigInt(component.amount) > 1 ? `(${component.amount})` : ""}`}
            </Menu.ItemText>
          </Menu.Item>
        ))}
      </Menu>
    </Fragment>
  );
};
